<template>
  <div class="context" style="height:1200px">
    <el-tabs type="border-card">
  <el-tab-pane label="酒店配置">
    
    <el-form  class="demo-form-inline" :model="ruleForm" ref="ruleForm">
      <el-form-item label="酒店门头照片">
        <div>
          <el-upload
            class="upload-demo"
            action="/api2/minio/uploadFile"
            :headers="config"
            :on-preview="handlePreview"
            :on-success="fileSuccess"
            :on-remove="removeFile"
            :file-list="fileList"
            :before-upload="beforeAvatarUpload"
             list-type="picture-card"
            :limit=1
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </div>
        
      </el-form-item>

      <el-form-item label="酒店名称" prop="name">
        <el-input v-model="ruleForm.hotelName"></el-input>
      </el-form-item>

      <el-form-item label="酒店电话(前台/售后)" prop="name">
      <el-input v-model="ruleForm.hotelPhone"></el-input>
      </el-form-item>

      <el-form-item label="酒店简介" prop="name">
      <el-input  type="textarea" v-model="ruleForm.hotelIntroduction"></el-input>
      </el-form-item>

      <el-form-item label="酒店精确地址">
        <el-input  type="textarea" v-model="ruleForm.hotelAddress"></el-input>
      </el-form-item>

      <el-form-item label="微信下单被通知人用户编号 列如：HD0000001 填写1 即可。(用户下单被通知人将收到微信公众号的通知)" prop="name">
        <el-input v-model="ruleForm.hotelPerson"></el-input>
      </el-form-item>



      <el-form-item>
        <div style="text-align: right;">
          <el-button type="primary" @click="hotelScan()">保存并预览</el-button>
          <el-button type="primary" @click="hotelInfoSubmitForm()">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-tab-pane>

   <el-tab-pane label="营销中心">
     <el-form  class="demo-form-inline" :model="ruleForm" ref="ruleForm" label-width="50rpx">
      <el-form-item label="营销功能">
        <el-select v-model="market.isShow" placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
      </el-form-item>
      <el-form-item label="微信二维码">
        <el-upload
            class="upload-demo"
            action="/api2/minio/uploadFile"
            :headers="config"
            :on-success="fileSuccess2"
            :on-remove="removeFile2"
            :file-list="fileList2"
             list-type="picture-card"
            :limit=1
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
      </el-form-item>


      <el-form-item label="兑换礼物名称(例如:可乐一瓶[礼物+数量])" prop="name">
        <el-input v-model="market.gift"></el-input>
      </el-form-item>
<!-- 
      <el-form-item label="兑换口令" prop="name">
        <el-input v-model="market.giftKey"></el-input>
      </el-form-item> -->

  

      <el-form-item>
        <div style="text-align: right;"> 
    
          <el-button type="primary" @click="saveMarket()">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-tab-pane>


  <!-- <el-tab-pane label="个人信息">
     <el-form  class="demo-form-inline" :model="ruleForm" ref="ruleForm" label-width="50rpx">
      <el-form-item label="酒店名称">
        <el-input disabled v-model="ruleForm.nickName"></el-input>
      </el-form-item>
      <el-form-item label="手机号(登录账号)">
        <el-input disabled v-model="ruleForm.phone"></el-input>
      </el-form-item>


      <el-form-item label="地址" prop="name">
        <el-input v-model="ruleForm.city"></el-input>
      </el-form-item>

      <el-form-item label="余额" prop="name">
       <span>{{ruleForm.money}}</span>
      </el-form-item>

      <el-form-item label="低于10元短信通知" prop="name">
        <el-select v-model="ruleForm.status" >
          <el-option label="开启" value=0></el-option>
          <el-option label="关闭" value=1></el-option>
        </el-select>
      </el-form-item>


      <el-form-item>
        <div style="text-align: right;"> 
    
          <el-button type="primary" @click="hotelInfoSubmitForm()">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-tab-pane> -->
</el-tabs>

<el-dialog
  title="微信扫一扫预览"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
  <div style="text-align:center">
    <img :src="scan" style="width:100%;height:100%" />
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog>

   
  </div>
</template>

<script>


export default {
  data() {
    return {
      fileList2:[],
      options: [{
          value: 0,
          label: '打开'
        }, 
        {
          value: 1,
          label: '关闭'
        }, 
          
        ],
      scan:"",
      dialogVisible:false,
      loading: true,
      ruleForm: {
        id:"",
        fileList:[],
        hotelName: "",
        hotelPhone: "",
        hotelAddress: "",
        hotelIntroduction:"",
        hotelDoor:"",
        hotelPerson:"",
        userId:""
      },
      modelShow: false,
      market:""
    };
  },
  mounted() {
    this.ruleForm.userId=this.$store.state.user.user.id
    this.pushdata();
    this.getMyMarket()
  },
  methods: {
  
    getMyMarket(){
      var that = this;
      that.$axios
        .get("/api2/business/getMyMarket/"+this.$store.state.user.user.id, {})
        .then(function (response) {
          that.market=response.data.data
          that.fileList2.push({ 
          url:that.market.wxCode
        });
        });
    },
    saveMarket(){
      var that = this;
      that.$axios
        .post("/api2/business/saveOrUpdateMarket", this.market)
        .then(function (response) {
          that.$message.success(response.data.msg);
          that.getMyMarket()
        });
    },
    hotelScan(){
      var that = this;
      that.$axios
        .post("/api2/business/saveHotelInfo", this.ruleForm)
        .then(function (response) {
          that.dialogVisible=true
          that.scan="http://localhost:8082/code/wxpay?content=https://www.165game.fun/xcx/#/pages/load/load?userId="+that.$store.state.user.user.id
        });
     
    },
    removeFile(file, fileList) {
      this.ruleForm.fileList = fileList;
    },
    removeFile2(file, fileList) {
      this.ruleForm.fileList = fileList;
    },

    fileSuccess(response, file, fileList) {
      console.log(response)
      this.ruleForm.fileList.push({ 
        url: response.msg
      });
      this.ruleForm.hotelDoor=response.msg
      console.log(response);
      console.log(file);
      console.log(fileList);
    },
    fileSuccess2(response, file, fileList) {
      console.log(response)
      this.fileList2=[]
      this.fileList2.push({ 
        url: response.msg
      });
      this.market.wxCode=response.msg
    },
    hotelInfoSubmitForm(){
      var that = this;
      that.$axios
        .post("/api2/business/saveHotelInfo", this.ruleForm)
        .then(function (response) {
          that.$message.success(response.data.msg);
          that.getHotelInfo()
        });
    },
    submitForm(){
 
      var that = this;
      that.$axios
        .post("/api2/user/registerByAdmin", this.ruleForm)
        .then(function (response) {
          that.$message.success(response.data.msg);
          that.pushdata()
        });
    },
    reset() {
      this.req.pageIndex = 0
      this.req.pageCount = 10
    },
    clear() {
      this.req.parma = ""
      this.reset()
      this.pushdata()
    },
    selectByQuery() {
      this.req.pageIndex = 0;
      this.pushdata();
    },
    updateUser(row) {
      this.modelShow = true,
        setTimeout(() => {
          this.$refs['userModel'].init(row.id)//用$refs赋值调用子组件的init方法
        }, 500)
    },
    userShowChange(visible) {
      this.modelShow = visible
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      if (val != 1) {
        var statcount = (val - 1) * this.req.pageCount;
        this.req.pageIndex = statcount;
        console.log("当前开始index--" + statcount);
      }
      else {
        this.req.pageIndex = 0;
        console.log("当前开始index--" + statcount);
      }
      console.log(this.req);
      this.pushdata();
    },
    getHotelInfo(){
      var that = this;
      that.$axios
        .get("/api2/business/getHotelInfo/"+this.$store.state.user.user.id, {})
        .then(function (response) {
          that.loading = false
          that.ruleForm = response.data.data;
          var list=[]
        list.push(
          {url:response.data.data.hotelDoor}
        )
        that.fileList=list
        console.log(list)
        });
       
    
    },
    pushdata() {
      this.getHotelInfo()
    }
  },

}
</script>
<style scoped>
</style>
